import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-key-executives',
  templateUrl: './key-executives.component.html',
  styleUrls: ['./key-executives.component.scss']
})
export class KeyExecutivesComponent implements OnInit {

  public officesList: any = [];
  constructor() { }

  ngOnInit(): void {
    this.officesList = [
      {
        "sNo": 1,
        "officeName": "Sh. Sanjay Rahar",
        "designation": "SE, Rohtak",
        "contact_landLine": "01262-256006",
        "contact_mobile": 9416322922,
        "email_address": "secadrtk2@gmail.com"
      },
      {
        "sNo": 2,
        "officeName": "Sh. Dhoop Singh",
        "designation": "SE, Hisar",
        "contact_landLine": "01662-227369",
        "contact_mobile": 9416256246,
        "email_address": "secadhisar01@gmail.com"
      },
      {
        "sNo": 3,
        "officeName": "Sh. Kamal Kant",
        "designation": "SE, Karnal",
        "contact_landLine": "01746-222028",
        "contact_mobile": 9416369365,
        "email_address": "sekaithalcad@gmail.com"
      },
      {
        "sNo": 4,
        "officeName": "Sh. Navdeep Rathore",
        "designation": "SE, MEQC Panchkula",
        "contact_landLine": "0172-2583175",
        "contact_mobile": 9467282039,
        "email_address": "semeqcpkl@gmail.com"
      },
      {
        "sNo": 5,
        "officeName": "Sh. Deepak",
        "designation": "Executive Engineer, Monitoring, Evaluation & Quality Control, Panchkula",
        "contact_landLine": "0172-2583175",
        "contact_mobile": 9813415012,
        "email_address": "xenmeqcpkl@gmail.com"
      },
      {
        "sNo": 6,
        "officeName": "Sh. Anshul Kadiyan",
        "designation": "XEN, Rohtak",
        "contact_landLine": "01262-254552",
        "contact_mobile": 9650044885,
        "email_address": "xenrohtakcad@gmail.com"
      },
      {
        "sNo": 7,
        "officeName": "Sh. Jai Parkash Tanwar",
        "designation": "XEN, Jhajjar",
        "contact_landLine": "01251-257076",
        "contact_mobile": 9899000779,
        "email_address": "xenjhajjarcad1@gmail.com"
      },
      {
        "sNo": 8,
        "officeName": "Sh. Attinder Pal",
        "designation": "XEN, Jind",
        "contact_landLine": "01681-227072",
        "contact_mobile": 9991129289,
        "email_address": "xenjindcad1@gmail.com"
      },
      {
        "sNo": 9,
        "officeName": "Sh. Vikas Sheravat (CDC)",
        "designation": "XEN, Rewari",
        "contact_landLine": "01274-260404",
        "contact_mobile": 8059001709,
        "email_address": "xenrewaricad1@gmail.com"
      },
      {
        "sNo": 10,
        "officeName": "Sh. Sonit Rahee",
        "designation": "XEN, Mahendagarh",
        "contact_mobile": 8053659947,
        "email_address": "xencadelectmgarh@gmail.com"
      },
      {
        "sNo": 11,
        "officeName": "Sh. Kuljeet Singh",
        "designation": "XEN, Faridabad",
        "contact_landLine": "0129-2972202",
        "contact_mobile": 7838800054,
        "email_address": "xenmicadafbd@gmail.com"
      },
      {
        "sNo": 12,
        "officeName": "Sh. Dharam Pal",
        "designation": "XEN, Hisar",
        "contact_landLine": "01662-235425",
        "contact_mobile": 9467329320,
        "email_address": "xenhisarcad1@gmail.com"
      },
      {
        "sNo": 13,
        "officeName": "Sh. Munish Deshwal",
        "designation": "XEN, Bhiwani",
        "contact_landLine": "01664-244273",
        "contact_mobile": 9802223366,
        "email_address": "xenmicadbwn@gmail.com"
      },
      {
        "sNo": 14,
        "officeName": "Sh. Sanjeev Kumar",
        "designation": "XEN, Fatehabad",
        "contact_landLine": "01667-227125",
        "contact_mobile": 9215041185,
        "email_address": "xenfatehbadcad1@gmail.com"
      },
      {
        "sNo": 15,
        "officeName": "Sh. VPS Rathee",
        "designation": "XEN, Sirsa",
        "contact_landLine": "01666-244129",
        "contact_mobile": 9416047333,
        "email_address": "xensirsacad@gmail.com"
      },
      {
        "sNo": 16,
        "officeName": "Sh. Lalit",
        "designation": "XEN, Kaithal",
        "contact_landLine": "01746-224337",
        "contact_mobile": 8059933744,
        "email_address": "xenkaithalcad@gmail.com"
      },
      {
        "sNo": 17,
        "officeName": "Sh. Ajay",
        "designation": "XEN, Karnal",
        "contact_landLine": "0184-2271054",
        "contact_mobile": 9467444401,
        "email_address": "xenkarnalcad@gmail.com"
      },
      {
        "sNo": 18,
        "officeName": "Sh. Suraj Parkash Saini",
        "designation": "XEN, Kurukshetra",
        "contact_landLine": "01744-238740",
        "contact_mobile": 9034414140,
        "email_address": "xenkurukshetracad@gmail.com"
      },
      {
        "sNo": 19,
        "officeName": "Sh. Manish kumar",
        "designation": "XEN, Panipat",
        "contact_landLine": "0180-2650805",
        "contact_mobile": 9306392480,
        "email_address": "xencadpanipat@gmail.com"
      },
      {
        "sNo": 20,
        "officeName": "Sh. Rakesh Kumar Fulia",
        "designation": "XEN, MEQC Panchkula",
        "contact_landLine": "",
        "contact_mobile": 9466048880,
        "email_address": ""
      },
      {
        "sNo": 21,
        "officeName": "Sh. Deepak Kumar",
        "designation": "XEN(Works), MICADA HEAD OFFICE",
        "contact_landLine": "",
        "contact_mobile": 9813415012,
        "email_address": ""
      }
    ];
  }

}
